import { ServiceHeader } from '../../components/services/ServiceHeader';
import { ServiceHero } from '../../components/services/ServiceHero';
import { ReturnAffectifContent } from '../../components/services/ReturnAffectifContent';
import { ServiceFooter } from '../../components/services/ServiceFooter';
import { useContactActions } from '../../hooks/useContactActions';

export default function RetourAffectif() {
  const { handleWhatsAppClick, handleCallClick } = useContactActions('Bonjour Maître Diamma, je souhaite un retour affectif');
  return (
    <div className="site-theme service-page min-h-screen bg-black text-white">
      <ServiceHeader handleWhatsAppClick={handleWhatsAppClick} />
      <ServiceHero handleWhatsAppClick={handleWhatsAppClick} handleCallClick={handleCallClick} />
      <ReturnAffectifContent handleWhatsAppClick={handleWhatsAppClick} />
      <ServiceFooter />
    </div>
  );
}